<template>
    <FetchTable
        :handle="tableHandle"
        :url="table.url"
        :columns="table.columns"
        v-model:orders="table.orders"
        @click:filters-button="$refs.IntegrationOrdersFiltersModal.show()"
        @click:clear-filters="clearFilters"
        has-checkbox
        has-filters
        :active-filters-count="activeFiltersCount"
        v-model:selectedValues="selectedOrderUuids"
    >
        <template #actionDropdownItems>
            <DropdownItem @click="$refs.UpsertIntegrationOrderModal.show(selectedOrderUuids)">Оновити в СРМ</DropdownItem>
        </template>
        <template #td-id="{row}">
            <a :href="row.url">{{ row.source_id }}</a>
        </template>
        <template #td-integration_order="{row}">
            {{ row.status.name }}
        </template>
        <template #td-imported="{row}">
            <AppNullableCell>
                <template #default v-if="row.order">
                    {{ row.order.id }}
                </template>
            </AppNullableCell>
        </template>
        <template #td-created_at="{row}">
            {{ DateFormatter.formatDateTime(row.created_at) }}
        </template>
        <template #td-additional="{row}">
            <router-link class="btn btn-link legitRipple" :to="{name: 'EditOrderCard', params: { orderUuid: row.uuid }}">
                {{ $t("labels.more_details") }}
            </router-link>
        </template>
    </FetchTable>
    <IntegrationOrdersFiltersModal ref="IntegrationOrdersFiltersModal" @update:filters="updateFilters" :integration="integration" />
    <UpsertIntegrationOrderModal ref="UpsertIntegrationOrderModal" />
</template>
<script>
import FetchTable from '../../../../../../components/new/table/FetchTable.vue';
import { createTableHandle } from '../../../../../../components/new/table/tableHandle';
import AppNullableCell from "../../../../../components/tables/AppNullableCell.vue";
import IntegrationOrdersFiltersModal from "./IntegrationOrdersFiltersModal.vue";
import DropdownItem from '../../../../../../spa/components/btnDropdown/DropdownItem.vue';
import DateFormatter from "../../../../../../services/DateFormatter";
import UpsertIntegrationOrderModal from './modals/UpsertIntegrationOrderModal.vue';

export default {
    name: "IntegrationOrdersTable",
    components: {
        FetchTable, AppNullableCell, IntegrationOrdersFiltersModal, DropdownItem, UpsertIntegrationOrderModal
    },
    props: {
        integration: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            table: {
                url: `/integrations/${this.integration.uuid}/orders`,
                orders: [{
                    column: 'created_at',
                    dir: 'desc'
                }],
                columns: [
                    {key: 'id', name: this.$t('table.titles.external_id'), width: '80px', type: 'string', order: false},
                    {key: 'integration_order', name: this.$t('table.titles.status'), width: 'auto', type: 'string', order: false},
                    {key: 'imported', name: this.$t('table.titles.internal_id'), width: '200px', type: 'string', order: false},
                    {key: 'created_at', name: this.$t('table.titles.created_at'), width: '200px', type: 'string', order: true},
                    {key: "additional", name: '', width: "150px", type: "string", order: false}
                ]
            },
            selectedOrderUuids: [],
            activeFiltersCount: 0
        }
    },
    methods: {
        clearFilters() {
            this.$refs.IntegrationOrdersFiltersModal.clear();
        },
        updateFilters(filters) {
            this.activeFiltersCount = (filters.status_uuids?.length > 0 ? 1 : 0) + (filters.selectedInternalId ? 1 : 0);

            let requestBody = {
                status_uuids: filters.status_uuids
            };

            if (filters.selectedInternalId) {
                if (filters.selectedInternalId.key === 'present') {
                    requestBody.has_order = 1;
                } else if (filters.selectedInternalId.key === 'missing') {
                    requestBody.has_order = 0;
                }
            }

            this.tableHandle.page = 1;
            this.tableHandle.selectedValues = [];
            this.tableHandle.fetchRows(requestBody);
        },
        fetchRows() {
            this.tableHandle.fetchRows();
        }
    },
    mounted() {
        this.fetchRows();
    }
}
</script>
